import { cx } from "shared/utils";
import type { FC, MouseEventHandler, ReactNode } from "react";
import { Link } from "react-router-dom";

interface CardProps {
  className?: string;
  children: ReactNode;
  onClick?: MouseEventHandler<HTMLDivElement>;
  linkTo?: string;
}

export const Card: FC<CardProps> = ({
  children,
  className,
  onClick,
  linkTo
}) => {
  const classNames = cx(
    "rounded-lg border border-alpha-100 bg-content-1000-inverted  shadow-md",
    onClick || linkTo
      ? "hover:border-alpha-200 hover:shadow-lg cursor-pointer"
      : "",
    className
  );

  if (linkTo)
    return (
      <Link to={linkTo}>
        <div className={classNames}>{children}</div>
      </Link>
    );

  return (
    <div className={classNames} onClick={onClick}>
      {children}
    </div>
  );
};
